import { usePage } from "@inertiajs/vue3"

export default function createInertiaHeaders(additionalHeaders = {}) {
    const page = usePage()

    return {
        "X-Inertia": true,
        "X-Inertia-Version": page.version,
        ...additionalHeaders,
    }
}
